import { Component, OnInit } from '@angular/core'
import { KcDataService } from '../../kc-data.service'
import { KcMessage } from '../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-kc-message',
  templateUrl: './kc-message.component.html',
  styleUrls: ['./kc-message.component.scss']
})
export class KcMessageComponent implements OnInit {
  constructor(private readonly kcDataService: KcDataService) {}

  public message: KcMessage

  ngOnInit() {
    this.message = this.kcDataService.getMessage()
  }
}
